import React, { Component } from "react";
import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import * as sisMapActions from "store/modules/rds_sisMap";
import * as layoutActions from "store/modules/rds_layout";

import SisModal from "store/sis/sisModal";

import stl from "./flight.module.scss";

class Flight extends Component {
	state = {
		data: [],
	};

	componentDidMount() {
		const { LayoutActions } = this.props;
		LayoutActions.setModal({
			id: "flightModal",
			target: this,
		});
	}

	setData = (data) => {
		let list = [];
		const date = new Date();
		const now = date.getFullYear() + "" + appendZeroValue(date.getMonth() + 1) + "" + appendZeroValue(date.getDate()) + appendZeroValue(date.getHours()) + "" + appendZeroValue(date.getMinutes());
		data.list.forEach((item) => {
			if (parseInt(now) < parseInt(item.depPlandTime.substring(0, 12))) {
				list.push(item);
			}
		});

		data.list = list;
		this.setState({
			data,
		});
	};

	render() {
		const { data } = this.state;

		const contents = (
			<div className={stl.flightWrap}>
				<div className={stl.titleWrap}>
					<span className={stl.posLabel}>{`${data.selectDate} [ ${data.startPortName} → ${data.endPortName} ] `}</span>
					<span className="">조회결과</span>
				</div>

				<div className={stl.infoWrap}>※ 본 정보는 각 항공사의 사정에 따라 변경될 수 있습니다. 최신정보 및 각 공항별 연락처는 항공정보포털시스템 홈페이지(<a href="http://airportal.go.kr" target="_blank">http://airportal.go.kr</a>)에서 확인하시기 바랍니다.</div>

				<div className={stl.contentsWrap}>
					<table>
						<caption>조회결과</caption>
						<thead>
							<tr>
								<th>항공편명</th>
								<th>출발시간</th>
								<th>도착시간</th>
								<th>일반석운임</th>
								<th>비즈니스석운임</th>
							</tr>
						</thead>
						<tbody>
							{data.list !== undefined &&
								data.list.length > 0 &&
								data.list.map((item, idx) => {
									let rslt = "";

									const depTime = item.depPlandTime.substring(8, 10) + ":" + item.depPlandTime.substring(10, 12);

									const arrTime = item.arrPlandTime.substring(8, 10) + ":" + item.arrPlandTime.substring(10, 12);

									if (item.airlineNm !== null) {
										rslt = (
											<tr key={idx}>
												<td>{`${item.airlineNm}(${item.vihicleId})`}</td>
												<td>{depTime}</td>
												<td>{arrTime}</td>
												<td>{item.economyCharge !== null ? item.economyCharge.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "-"}</td>
												<td>{item.prestigeCharge !== null ? item.prestigeCharge.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "-"}</td>
											</tr>
										);
									}

									return rslt;
								})}
							{data.list !== undefined && data.list.length === 0 && (
								<tr>
									<td colSpan="5">조회하신 정보가 존재하지 않습니다.</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>
			</div>
		);

		return (
			<div>
				<SisModal id={this.props.id} className={stl.flightModal} title="항공 운행시간 조회" draggable contents={contents} />
			</div>
		);
	}
}

function appendZeroValue(target) {
	if (target.toString().length === 1) {
		return "0" + target;
	} else {
		return target;
	}
}

export default compose(
	withRouter,
	connect(
		(state) => ({
			layout: state.layout,
			sis: state.sisMap,
		}),
		(dispatch) => ({
			SisMapActions: bindActionCreators(sisMapActions, dispatch),
			LayoutActions: bindActionCreators(layoutActions, dispatch),
		})
	)
)(Flight);
